import { Collapse, List, Space, Tag, Typography } from 'antd';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EMPTY_DISPLAY_VALUE } from '@shared/constants/display';

const { Text } = Typography;

const ENTITY_LABELS = {
	quotation: 'Cotización',
	vehicle: 'Vehículo',
	client: 'Tomador',
}

const ChangeDetails = ({ entity, actionType, title, changes }) => {
	const entityLabel = (
		<Space direction='vertical' size='small'>
			<Text>{title}:</Text>
			<Tag color='blue' style={{ maxWidth: '27em' }}>
				<Text
					ellipsis={{ tooltip: { mouseEnterDelay: 0.3 } }}
					style={{ color: 'inherit' }}
				>
					{ENTITY_LABELS[entity.name] ?? entity.name}: {entity.summary}
				</Text>
			</Tag>
		</Space>
	);

	if (!Object.keys(changes).length) return entityLabel;

	const changeEntries = Object.entries(changes);

	return (
		<Collapse
			size='small'
			expandIconPosition='end'
			expandIcon={({ isActive }) => <FontAwesomeIcon icon={faCaretRight} rotation={isActive ? 90 : 0} />}
			items={[{
				key: '1',
				label: entityLabel,
				children: (
					<List
						// header={'Detalles'}
						dataSource={changeEntries}
						renderItem={([field, { previous, current }], index) => {
							const renderValue = (value) => (
								<Text type={value === EMPTY_DISPLAY_VALUE ? 'secondary' : undefined}>
									{String(value)}
								</Text>
							);

							const listItemStyle = {
								display: 'block',
								paddingTop: index === 0 ? 0 : undefined, // Evita el padding-top en el primer elemento
								paddingBottom: index === changeEntries.length - 1 ? 0 : undefined, // Evita el padding-bottom en el último elemento
							};

							if (actionType === 'requote') {
								return (
									<List.Item style={listItemStyle}>
										<Text strong>{current?.name}</Text>
									</List.Item>
								);
							}

							return (
								<List.Item style={listItemStyle}>
									<Text strong>{`${field}: `}</Text>
									{(actionType === 'update' || actionType === 'delete') && renderValue(previous)}
									{actionType === 'update' && <Text strong> por </Text>}
									{(actionType === 'create' || actionType === 'update') && renderValue(current)}
								</List.Item>
							);
						}}
					/>
				),
			}]}
		/>
	);
};

export default ChangeDetails;
